import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import TextBox from "@/js/common/ui/input/TextBox";
import SelectBox from "@/js/common/ui/input/SelectBox";

interface Props {
    onPick: (item: any) => void;
    setModalOpen: Function;
    initUpOgnzCd: string;
    selectedUserIds?: string[];
    currentUserId?: string;
}

const MbrasAprvrAuthMbrPickDialog = ({
    onPick,
    setModalOpen,
    initUpOgnzCd,
    selectedUserIds = [],
    currentUserId = "",
}: Props) => {
    const [keyword, setKeyword] = React.useState<string>("");
    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(initUpOgnzCd);
    const [jbpsSeCd, setJbpsSeCd] = React.useState<string>("");

    const [dataArr, setDataArr] = React.useState<any[]>([]);

    const selectedSet = React.useMemo(() => {
        const set = new Set<string>();

        (selectedUserIds || [])
            .map((v) => String(v || "").trim())
            .filter((v) => v !== "")
            .forEach((v) => set.add(v));

        const cur = String(currentUserId || "").trim();

        if (cur) {
            set.delete(cur);
        }

        return set;
    }, [selectedUserIds, currentUserId]);

    const fldInfs = React.useMemo<fldInfsProps[]>(
        () => [
            {
                type: "seq",
                width: 50,
                headAlign: "center",
                dataAlign: "center",
                label: "No.",
            },
            {
                type: "text",
                fldNm: "userId",
                width: 100,
                headAlign: "center",
                dataAlign: "center",
                label: "아이디",
            },
            {
                type: "text",
                fldNm: "userNm",
                width: 100,
                headAlign: "center",
                dataAlign: "center",
                label: "이름",
            },
            {
                type: "text",
                fldNm: "upOgnzNm",
                width: 150,
                headAlign: "center",
                dataAlign: "center",
                label: "본부",
            },
            {
                type: "text",
                fldNm: "ognzNm",
                width: 150,
                headAlign: "center",
                dataAlign: "center",
                label: "지부",
            },
            {
                type: "text",
                fldNm: "jbpsSeNm",
                width: 100,
                headAlign: "center",
                dataAlign: "center",
                label: "직위",
                catCode: "JBPS_SE_CD",
            },
        ],
        []
    );

    React.useEffect(() => {
        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/sys/aprvr/select-mbras-aprvr-auth-mbr-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                keyword,
                upOgnzCd,
                jbpsSeCd,
            },
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list);
                AppContext.hideSpinner();
            },
        });
    }, [keyword, upOgnzCd, jbpsSeCd]);

    return (
        <div className="w100p">
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    <div className="dpFlx aiC">
                        <span className="w120 fm-c fs15 fc333333 ls1 taL">
                            검색어(ID/이름)
                        </span>

                        <TextBox
                            value={keyword}
                            width={180}
                            height={36}
                            fontSize={14}
                            fontFamily="fm-c"
                            color="#333"
                            letterSpacing={-1}
                            borderColor="#ddd"
                            borderOnColor="#222"
                            borderRadius={2}
                            style={{
                                backgroundColor: "#fff",
                                padding: "0 12px",
                            }}
                            placeholder="신청 ID 또는 이름"
                            onChangeFunc={(text: string) => setKeyword(text)}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w60 fm-c fs15 fc333333 ls1 taL">
                            직위
                        </span>

                        <SelectBox
                            value={jbpsSeCd}
                            width={180}
                            height={36}
                            fontSize={14}
                            fontFamily="fm-c"
                            color="#333"
                            letterSpacing={-1}
                            borderColor="#ddd"
                            borderOnColor="#222"
                            borderRadius={2}
                            background="#fff"
                            codeArray={[
                                { code: "", name: "전체" },
                            ].concat(Util.getCodeArray("JBPS_SE_CD"))}
                            placeholder="전체"
                            paddingRight={8}
                            onChangeFunc={(data: string) => setJbpsSeCd(data)}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w60 fm-c fs15 fc333333 ls1 taL">
                            본부
                        </span>

                        <SelectBox
                            value={upOgnzCd}
                            width={150}
                            height={36}
                            fontSize={14}
                            fontFamily="fm-c"
                            color="#333"
                            letterSpacing={-1}
                            borderColor="#ddd"
                            borderOnColor="#222"
                            borderRadius={2}
                            background="#f6f6f6"
                            disabled={true}
                            codeArray={[
                                { code: "", name: "전체" },
                            ].concat(Util.getUpOrgCodeArray("01"))}
                            placeholder="전체"
                            paddingRight={8}
                            onChangeFunc={(data: string) => {
                                setUpOgnzCd(data);
                            }}
                        />
                    </div>

                    <div className="dpFlx aiC mlA gap8">
                        <Button
                            width={70}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styInitBtn"
                            borderRadius={5}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="초기화"
                            onClickFunc={() => {
                                setKeyword("");
                                setJbpsSeCd("");
                            }}
                        />
                    </div>
                </div>
            </div>

            <GridTable
                tableInfo={{
                    tableHeadVsb: true,
                    styleType: AdminGridStyle,
                    fldInfs,
                    ordFld: {
                        name: "userId",
                        direction: "desc",
                    },
                    dataArr: dataArr,
                    maxRowNums: [10, 20, 30],
                    theadTrHeight: 40,
                    tbodyTrHeight: 35,
                    heightType: "fix",
                    bodyHeight: 350,
                    remainArea: true,
                    paginateClass: "pt10",
                    paginateStyle: {
                        buttonOnColor: AppContext.boardThemeColor,
                        buttonWidth: 22,
                        buttonHeight: 24,
                        buttonMarginLeft: 1,
                        buttonMarginRight: 1,
                        fontSize: 13,
                        color: "#666666",
                        letterSpacing: -0.8,
                        fontFamily: "Pretendard-Regular",
                        borderRadius: 3,
                    },
                    footerVsb: true,
                    rowClickFunc: (item: any) => {
                        const pickId = String(item.userId || "").trim();

                        if (selectedSet.has(pickId)) {
                            AppContext.openAlert({
                                title: "중복 선택",
                                msg: "이미 결재자로 등록된 회원입니다.",
                                icon: "warning",
                                closeText: "확인",
                            });

                            return;
                        }

                        onPick(item);
                        setModalOpen(false);
                    },
                }}
            />

            <div className="dpFlx jcC mt20 pb20">
                <Button
                    width={120}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={16}
                    letterSpacing={-1}
                    variant="styCloseBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="닫기"
                    onClickFunc={() => setModalOpen(false)}
                />
            </div>
        </div>
    );
};

export default MbrasAprvrAuthMbrPickDialog;